export default "__VITE_ASSET__CVlNhcGK__"